import Row from './container/layout/row/Index.vue'
import Col from './container/layout/col/Index.vue'
import DialogManager from './container/dialog/Index.vue'
import Scroller from './container/scroller/Index.vue'
import Picker from './container/dialog/picker/Index.vue'
import Swipe from './container/swipe/Index.vue'
import Tabs from './container/tabs/Index.vue'
import Lazy from './container/lazy/Index.vue'
import Form from './container/form/Index.vue'
import FormField from './container/form/Field.vue'
import Tabbar from './container/tabbar/Index.vue'
import TabbarItem from './container/tabbar/TabbarItem.vue'
import Label from './viewable/form/label/Index.vue'
import Button from './viewable/form/button/Index.vue'
import Icon from './viewable/icon/Index.vue'
import BlendText from './viewable/blend-text/Index.vue'
import Text from './viewable/form/text/Index.vue'
import Switch from './viewable/form/switch/Index.vue'
import Checkbox from './viewable/form/checkbox/Index.vue'
import GroupButtons from './viewable/form/group-buttons/Index.vue'
import Upload from './viewable/form/upload/Index.vue'
import Stick from './container/stick/Index.vue'
import GroupList from './viewable/group-list/Index.vue'
import Cuttle from './container/cuttle/Index.vue'
import Field from './viewable/field/Index.vue'
import Radio from './viewable/form/radio/Index.vue'
import Step from './viewable/steps/Index.vue'
import SwipeCell from './container/swipe/SwipeCell.vue'

export default {
	Row,
	Col,
	DialogManager,
	Scroller,
	Picker,
	Swipe,
	Tabs,
	Lazy,
	Form,
	FormField,
	Tabbar,
	TabbarItem,
	Label,
	Button,
	Icon,
	BlendText,
	Text,
	Switch,
	Checkbox,
	GroupButtons,
	Upload,
	Stick,
	GroupList,
	Cuttle,
	Field,
	Radio,
	Step,
	SwipeCell
}